import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { FilterParams } from '../../../../components/context/filter'
import { CategoryGroupBy, typeToDisplay } from './GroupByHelper'

export const DownloadChart: React.FunctionComponent = (props) => {

    const [type, setType] = React.useState<string>()
    const toolbarItems = CategoryGroupBy({ onTypeChange: setType })
    if (!type) {
        return null
    }

    return (
        <BPMChart {...props} title='Number of Downloads' subTitle={'By ' + typeToDisplay(type)} type='doughnut'
            onRequestLoad={(options: Partial<FilterParams>, signal) => {
                delete options.start_date
                delete options.end_date
                return BPMAnalyticsAPI.get<any>('downloads/byGroup', options, signal)
            }} additionalParams={{ groupBy: type }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Number of Downloads',
                valueField: 'count', argumentField: type,
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Category/charts/DownloadChart.tsx